export function property(state = {}, action) {
  switch (action.type) {
    case "GET_PROPERTY_INFO_SUCCESS":
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
}
